// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {SimpleBoxLoaderCommonLayout} from 'app_components/commons/loaderSkeletons/simpleBoxLoader'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface ISimpleBoxLoaderCommonProps {
  width?: number | string
  height?: number | string
  animationSpeed?: number
  borderRadius?: number | string
  backgroundColor?: string
  foregroundColor?: string
  style?: React.CSSProperties
}
interface ISimpleBoxLoaderCommonState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class SimpleBoxLoaderCommon extends Component<ISimpleBoxLoaderCommonProps, ISimpleBoxLoaderCommonState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ISimpleBoxLoaderCommonProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <SimpleBoxLoaderCommonLayout
        {...this.props}
      />
    )
  }
}

export default connect(mapStatesToProps)(SimpleBoxLoaderCommon)
